module.exports = __webpack_public_path__ + "static/media/genwest-large-banner-image-2x.4d680130.jpg";